export enum ProductTypes {
  EXPLANNER = 'EXPLANNER',
  TOOLBOX = 'TOOLBOX',
  ROOMS = 'ROOMS',
  ASSETS = 'ASSETS',
  GALAXY = 'GALAXY',
  MUSDB = 'MUSDB',
}
